import { useEffect, useState } from "react";
import {
  Button,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import KnifeModal from "../components/KnifeModal";
import { listKnivesPaged, deleteKnife } from "../api/knives";
import { EmptyState, PageHeader, StatusBadge } from "../components/ui";

function Knives() {
  const [list, setList] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [total, setTotal] = useState(0);

  function load() {
    listKnivesPaged({ page: page + 1, limit: rowsPerPage })
      .then((data) => {
        setList(data?.items || []);
        setTotal(Number(data?.total || 0));
      })
      .catch((err) => {
        console.error("KNIVES LOAD ERROR", err);
        alert("Bıçaklar yüklenemedi");
        setList([]);
        setTotal(0);
      });
  }

  useEffect(() => {
    load();
  }, [page, rowsPerPage]);

  function remove(id) {
    if (!window.confirm("Silmek istiyor musun?")) return;
    deleteKnife(id)
      .then(() => load())
      .catch((err) => {
        console.error("KNIFE DELETE ERROR", err);
        alert("Silinemedi");
      });
  }

  return (
    <Stack spacing={2}>
      <PageHeader
        title="Bıçaklar"
        subtitle="Kesim bıçaklarını ve tabak parametrelerini yönetin."
        actions={
          <Button
            variant="contained"
            onClick={() => {
              setSelected(null);
              setModalOpen(true);
            }}
          >
            + Yeni Bıçak
          </Button>
        }
      />

      {!list.length ? (
        <EmptyState description="Henüz bıçak tanımı yok." actionLabel="+ Yeni Bıçak" onAction={() => setModalOpen(true)} />
      ) : (
        <Paper>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Tabak Sayısı</TableCell>
                <TableCell>Tabak Ölçüsü (cm)</TableCell>
                <TableCell>Kalıp Tipi</TableCell>
                <TableCell align="right">Mt/Tabak</TableCell>
                <TableCell align="right">Alan (m²)</TableCell>
                <TableCell align="right">Adet/Mt</TableCell>
                <TableCell>Durum</TableCell>
                <TableCell align="right">İşlemler</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {list.map((x) => (
                <TableRow key={x.id} hover>
                  <TableCell>
                    <Typography sx={{ fontWeight: 800 }}>{x.plates_count}</Typography>
                  </TableCell>
                  <TableCell>{Number(x.diameter_cm)}</TableCell>
                  <TableCell>{x.mold_type}</TableCell>
                  <TableCell align="right">{Number(x.mt_per_plate).toFixed(6)}</TableCell>
                  <TableCell align="right">{Number(x.plate_area_m2).toFixed(6)}</TableCell>
                  <TableCell align="right">{Number(x.pieces_per_1mt).toFixed(4)}</TableCell>
                  <TableCell>
                    <StatusBadge value={x.status || "—"} />
                  </TableCell>
                  <TableCell align="right">
                    <Stack direction="row" spacing={1} justifyContent="flex-end">
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => {
                          setSelected(x);
                          setModalOpen(true);
                        }}
                      >
                        Düzenle
                      </Button>
                      <Button size="small" color="error" variant="outlined" onClick={() => remove(x.id)}>
                        Sil
                      </Button>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            component="div"
            count={total}
            page={page}
            onPageChange={(_, newPage) => setPage(newPage)}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setPage(0);
            }}
            rowsPerPageOptions={[10, 25, 50, 100]}
            labelRowsPerPage="Sayfa başına kayıt"
          />
        </Paper>
      )}

      {modalOpen ? (
        <KnifeModal
          data={selected}
          onClose={() => setModalOpen(false)}
          onSaved={() => load()}
        />
      ) : null}
    </Stack>
  );
}

export default Knives;
